// @ts-check
const decorStarsDesktop = [
  {
    name: 'fill-1',
    color: '#FB8547',
    width: '48px',
    left: '40px',
    top: '657px',
    angle: -0.21,
  },
  {
    name: 'fill-2',
    color: '#114837',
    width: '31px',
    left: '108px',
    top: '720px',
    angle: 2.16,
  },
  {
    name: 'fill-3',
    color: '#F7B8AE',
    width: '31px',
    left: '175px',
    top: '683px',
    angle: 0.91,
  },
  {
    name: 'fill-4',
    color: '#80A08D',
    width: '46px',
    left: '275px',
    top: '664px',
    angle: 0.59,
  },
  {
    name: 'fill-5',
    color: '#F7B8AE',
    width: '28px',
    left: '393px',
    top: '630px',
    angle: 0.7,
  },
  {
    name: 'fill-6',
    color: '#F6D500',
    width: '24px',
    left: '694px',
    top: '649px',
    angle: 0.93,
  },
  {
    name: 'fill-7',
    color: '#80A08D',
    width: '36px',
    left: '749px',
    top: '699px',
    angle: 0.56,
  },
  {
    name: 'fill-8',
    color: '#F7B8AE',
    width: '22px',
    left: '840px',
    top: '673px',
    angle: 0.71,
  },
  {
    name: 'fill-9',
    color: '#C9CFDA',
    width: '46px',
    left: '900px',
    top: '686px',
    angle: 0.6,
  },
  {
    name: 'fill-10',
    color: '#F6D500',
    width: '26px',
    left: '988px',
    top: '695px',
    angle: 0.7,
  },
];

const decorStarsMobile = [
  {
    name: 'fill-1',
    color: '#114837',
    width: '14px',
    left: '7px',
    top: '617px',
    angle: -0.34,
  },
  {
    name: 'fill-2',
    color: '#F6D500',
    width: '14px',
    left: '31px',
    top: '593px',
    angle: -0.36,
  },
  {
    name: 'fill-3',
    color: '#80A08D',
    width: '21px',
    left: '65px',
    top: '576px',
    angle: -0.61,
  },
  {
    name: 'fill-4',
    color: '#F7B8AE',
    width: '13px',
    left: '136px',
    top: '576px',
    angle: -0.61,
  },
  {
    name: 'fill-5',
    color: '#80A08D',
    width: '21px',
    left: '239px',
    top: '580px',
    angle: -0.61,
  },
  {
    name: 'fill-6',
    color: '#C9CFDA',
    width: '21px',
    left: '285px',
    top: '605px',
    angle: 0,
  },
];

export { decorStarsDesktop, decorStarsMobile };
